import * as ambassadorWixMembersV1CustomFieldApplication from './members-v1-custom-field-application-custom-field-applications.http.js';
import * as ambassadorWixMembersV1CustomFieldApplicationTypes from './members-v1-custom-field-application-custom-field-applications.types.js';
import * as ambassadorWixMembersV1CustomFieldApplicationUniversalTypes from './members-v1-custom-field-application-custom-field-applications.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createCustomFieldApplication(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMembersV1CustomFieldApplicationUniversalTypes.CreateCustomFieldApplicationRequest,
  ambassadorWixMembersV1CustomFieldApplicationTypes.CreateCustomFieldApplicationRequest,
  ambassadorWixMembersV1CustomFieldApplicationUniversalTypes.CreateCustomFieldApplicationResponse,
  ambassadorWixMembersV1CustomFieldApplicationTypes.CreateCustomFieldApplicationResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMembersV1CustomFieldApplication.createCustomFieldApplication(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/custom-fields-applications',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteCustomFieldApplication(): __PublicMethodMetaInfo<
  'DELETE',
  { customFieldId: string },
  ambassadorWixMembersV1CustomFieldApplicationUniversalTypes.DeleteCustomFieldApplicationRequest,
  ambassadorWixMembersV1CustomFieldApplicationTypes.DeleteCustomFieldApplicationRequest,
  ambassadorWixMembersV1CustomFieldApplicationUniversalTypes.DeleteCustomFieldApplicationResponse,
  ambassadorWixMembersV1CustomFieldApplicationTypes.DeleteCustomFieldApplicationResponse
> {
  const payload = { customFieldId: ':customFieldId' } as any;

  const getRequestOptions =
    ambassadorWixMembersV1CustomFieldApplication.deleteCustomFieldApplication(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/custom-fields-applications/{customFieldId}',
    pathParams: { customFieldId: 'customFieldId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateCustomFieldApplication(): __PublicMethodMetaInfo<
  'PATCH',
  { applicationCustomFieldId: string },
  ambassadorWixMembersV1CustomFieldApplicationUniversalTypes.UpdateCustomFieldApplicationRequest,
  ambassadorWixMembersV1CustomFieldApplicationTypes.UpdateCustomFieldApplicationRequest,
  ambassadorWixMembersV1CustomFieldApplicationUniversalTypes.UpdateCustomFieldApplicationResponse,
  ambassadorWixMembersV1CustomFieldApplicationTypes.UpdateCustomFieldApplicationResponse
> {
  const payload = {
    application: { customFieldId: ':applicationCustomFieldId' },
  } as any;

  const getRequestOptions =
    ambassadorWixMembersV1CustomFieldApplication.updateCustomFieldApplication(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/custom-fields-applications/{application.customFieldId}',
    pathParams: { applicationCustomFieldId: 'applicationCustomFieldId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getCustomFieldApplication(): __PublicMethodMetaInfo<
  'GET',
  { customFieldId: string },
  ambassadorWixMembersV1CustomFieldApplicationUniversalTypes.GetCustomFieldApplicationRequest,
  ambassadorWixMembersV1CustomFieldApplicationTypes.GetCustomFieldApplicationRequest,
  ambassadorWixMembersV1CustomFieldApplicationUniversalTypes.GetCustomFieldApplicationResponse,
  ambassadorWixMembersV1CustomFieldApplicationTypes.GetCustomFieldApplicationResponse
> {
  const payload = { customFieldId: ':customFieldId' } as any;

  const getRequestOptions =
    ambassadorWixMembersV1CustomFieldApplication.getCustomFieldApplication(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/custom-fields-applications/{customFieldId}',
    pathParams: { customFieldId: 'customFieldId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getCustomFieldApplications(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMembersV1CustomFieldApplicationUniversalTypes.GetCustomFieldApplicationsRequest,
  ambassadorWixMembersV1CustomFieldApplicationTypes.GetCustomFieldApplicationsRequest,
  ambassadorWixMembersV1CustomFieldApplicationUniversalTypes.GetCustomFieldApplicationsResponse,
  ambassadorWixMembersV1CustomFieldApplicationTypes.GetCustomFieldApplicationsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMembersV1CustomFieldApplication.getCustomFieldApplications(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/custom-fields-applications/applications',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getMembersCustomFieldApplications(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMembersV1CustomFieldApplicationUniversalTypes.GetMembersCustomFieldApplicationsRequest,
  ambassadorWixMembersV1CustomFieldApplicationTypes.GetMembersCustomFieldApplicationsRequest,
  ambassadorWixMembersV1CustomFieldApplicationUniversalTypes.GetMembersCustomFieldApplicationsResponse,
  ambassadorWixMembersV1CustomFieldApplicationTypes.GetMembersCustomFieldApplicationsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMembersV1CustomFieldApplication.getMembersCustomFieldApplications(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/custom-fields-applications/members',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getRolesCustomFieldApplications(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMembersV1CustomFieldApplicationUniversalTypes.GetRolesCustomFieldApplicationsRequest,
  ambassadorWixMembersV1CustomFieldApplicationTypes.GetRolesCustomFieldApplicationsRequest,
  ambassadorWixMembersV1CustomFieldApplicationUniversalTypes.GetRolesCustomFieldApplicationsResponse,
  ambassadorWixMembersV1CustomFieldApplicationTypes.GetRolesCustomFieldApplicationsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMembersV1CustomFieldApplication.getRolesCustomFieldApplications(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/custom-fields-applications/roles',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  CustomFieldApplication as CustomFieldApplicationOriginal,
  ApplicationsWrapper as ApplicationsWrapperOriginal,
  AppliesTo as AppliesToOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  ExclusionsWrapper as ExclusionsWrapperOriginal,
  Exclusion as ExclusionOriginal,
  ExclusionType as ExclusionTypeOriginal,
  ExclusionTypeWithLiterals as ExclusionTypeWithLiteralsOriginal,
  CreateCustomFieldApplicationRequest as CreateCustomFieldApplicationRequestOriginal,
  CreateCustomFieldApplicationResponse as CreateCustomFieldApplicationResponseOriginal,
  DeleteCustomFieldApplicationRequest as DeleteCustomFieldApplicationRequestOriginal,
  DeleteCustomFieldApplicationResponse as DeleteCustomFieldApplicationResponseOriginal,
  UpdateCustomFieldApplicationRequest as UpdateCustomFieldApplicationRequestOriginal,
  UpdateCustomFieldApplicationResponse as UpdateCustomFieldApplicationResponseOriginal,
  GetCustomFieldApplicationRequest as GetCustomFieldApplicationRequestOriginal,
  GetCustomFieldApplicationResponse as GetCustomFieldApplicationResponseOriginal,
  GetCustomFieldApplicationsRequest as GetCustomFieldApplicationsRequestOriginal,
  GetCustomFieldApplicationsResponse as GetCustomFieldApplicationsResponseOriginal,
  GetMembersCustomFieldApplicationsRequest as GetMembersCustomFieldApplicationsRequestOriginal,
  GetMembersCustomFieldApplicationsResponse as GetMembersCustomFieldApplicationsResponseOriginal,
  MemberCustomFieldApplication as MemberCustomFieldApplicationOriginal,
  FieldApplication as FieldApplicationOriginal,
  CustomField as CustomFieldOriginal,
  Privacy as PrivacyOriginal,
  PrivacyWithLiterals as PrivacyWithLiteralsOriginal,
  FieldTypeType as FieldTypeTypeOriginal,
  FieldTypeTypeWithLiterals as FieldTypeTypeWithLiteralsOriginal,
  SocialTypeType as SocialTypeTypeOriginal,
  SocialTypeTypeWithLiterals as SocialTypeTypeWithLiteralsOriginal,
  Origin as OriginOriginal,
  OriginWithLiterals as OriginWithLiteralsOriginal,
  AppliesToEnumAppliesTo as AppliesToEnumAppliesToOriginal,
  AppliesToEnumAppliesToWithLiterals as AppliesToEnumAppliesToWithLiteralsOriginal,
  Section as SectionOriginal,
  SectionWithLiterals as SectionWithLiteralsOriginal,
  GetRolesCustomFieldApplicationsRequest as GetRolesCustomFieldApplicationsRequestOriginal,
  GetRolesCustomFieldApplicationsResponse as GetRolesCustomFieldApplicationsResponseOriginal,
  RoleCustomFieldApplication as RoleCustomFieldApplicationOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './members-v1-custom-field-application-custom-field-applications.types.js';
